module.exports = __webpack_public_path__ + "assets/img/icon_service12.7807df14.png";